<template>
    <div>
        <div class="wrapper">
            <div class="animated fadeIn">
                <b-row>
                    <b-col cols="12" class="mb-3">
                        <b-button variant="primary" @click="$router.push('/admin/users/toevoegen')" class="pull-right">Gebruiker toevoegen</b-button>
                    </b-col>
                </b-row>
                <resource-index header="Gebruikers" endpoint="users" show-route="users.view"/>
            </div>
        </div>
    </div>
</template>

<script>
    import ResourceIndex from '../../components/ResourceIndex';

    export default {
        name: 'users',
        components: {ResourceIndex},
        computed: {
            userRole () {
                return this.$store.state.userRole
            }
        },
    }
</script>
